module.exports = __webpack_public_path__ + "img/cancel-gray.2dcf3a21.svg";